import {
  fork,
  put,
  all,
  call,
  takeLeading,
  takeLatest,
  take,
  cancel,
  select,
} from 'redux-saga/effects';
import types from './actionTypes';
import * as audiencesActions from './actions';
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  serverTimestamp,
} from 'firebase/firestore';
import rsf from '../../helpers/firebase';
import toastr from 'toastr';
import { toDateFirebase } from '../../helpers/sharedFunction';

const db = getFirestore(rsf.app);

function* createAudienceSaga({ audience }) {
  try {
    const audiencesRef = collection(db, 'audiences');
    const countryId = yield select((state) => state.Dashboard.countryId);

    yield call(rsf.firestore.addDocument, audiencesRef, {
      ...audience,
      setup: 'new',
      countryId,
      size: 0,
      createdAt: serverTimestamp(),
    });
    yield put(audiencesActions.createAudienceSuccess(audience));
    toastr.success('Audience created!', '');
  } catch (error) {
    yield put(audiencesActions.createAudienceFailure(error));
  }
}

function* updateAudienceSaga({ audience }) {
  try {
    const audiencesRef = doc(db, 'audiences', audience.id);
    delete audience.id;

    yield call(
      rsf.firestore.setDocument,
      audiencesRef,
      {
        ...audience,
        updatedAt: serverTimestamp(),
      },
      { merge: true },
    );
    yield put(audiencesActions.updateAudienceSuccess());
    toastr.success('Audience updated!', '');
  } catch (error) {
    yield put(audiencesActions.updateAudienceFailure(error));
  }
}

const audienceTransformer = (payload) => {
  let audiences = [];

  payload.forEach((audience) => {
    const data = audience.data();

    audiences.push({
      id: audience.id,
      ...data,
      ...(data.createdAt && {
        createdAt: toDateFirebase(audience, data).toDate(),
      }),
      ...(data.updatedAt && {
        updatedAt: toDateFirebase(audience, data, 'updatedAt').toDate(),
      }),
    });
  });

  return audiences;
};

function* syncAudiencesSaga() {
  const countryId = yield select((state) => state.Dashboard.countryId);
  const audiencesRef = query(
    collection(db, 'audiences'),
    where('countryId', '==', countryId),
    orderBy('createdAt', 'desc'),
  );

  const task = yield fork(rsf.firestore.syncCollection, audiencesRef, {
    successActionCreator: audiencesActions.syncAudiencesSuccess,
    failureActionCreator: audiencesActions.syncAudiencesFailure,
    transform: (payload) => audienceTransformer(payload),
  });

  yield take(types.RESET_AUDIENCE_STATE);
  yield cancel(task);
}

function* audienceSaga() {
  yield all([
    takeLatest(types.SYNC_AUDIENCES.REQUEST, syncAudiencesSaga),
    takeLeading(types.CREATE_AUDIENCE.REQUEST, createAudienceSaga),
    takeLatest(types.UPDATE_AUDIENCE.REQUEST, updateAudienceSaga),
  ]);
}

export default audienceSaga;
